import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-product-selection',
  templateUrl: './product-selection.component.html',
  styleUrls: ['./product-selection.component.css']
})
export class ProductSelectionComponent implements OnInit {

  logoUrl = "";
  manSeatingUrl = "";
  smoothieKing = "";
  openAccountUrl1 = "";
  openAccountUrl2 = "";
  openAccountUrl3 = "";
  headstarUrl = "";

  constructor() { }

  ngOnInit(): void {
    this.logoUrl = "/assets/TcbLogo.svg";
    this.manSeatingUrl = "/assets/man_seating.png";
    this.smoothieKing = "/assets/smoothie_king.png";
    this.headstarUrl = "/assets/headstar.png";
    this.openAccountUrl1 = '/product?product=9c85d725-69c9-4659-906e-94eb0f504860';
    this.openAccountUrl2 = '/product?product=9c85d725-69c9-4659-906e-94eb0f504860';
    this.openAccountUrl3 = '/product?product=9c85d725-69c9-4659-906e-94eb0f504860';

  }

  openAccount(targetUrl : string){
    let path = `${window.location.origin}${targetUrl}`;
    window.open(
      `${path}`,
      '_blank' 
    );
  }

}
